import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { WEEKDAY_LABELS, WORKDAY_PRESETS, workdayPreset } from '../constants/jobOptions';
import './WorkdaysPicker.css';

const WEEKDAYS = Object.keys(WEEKDAY_LABELS);

// Arbeitstage für Job-Formular, FilterDrawer und Setup-Wünsche. Oben die
// Schnellauswahl, darunter aufklappbar die einzelnen Tage. value/onChange ist
// nur die Tagesliste (mo…so); welcher Chip oben aktiv ist, folgt daraus.
// chipClass/activeClass: Chip-Optik der umgebenden Seite übernehmen.
export default function WorkdaysPicker({
  value = [],
  onChange,
  chipClass = 'filter-chip',
  activeClass = 'filter-chip--active',
}) {
  const preset = workdayPreset(value);
  // Abweichend vom Chip gespeichert (z.B. Mo, Mi) → Tage gleich zeigen
  const [open, setOpen] = useState(value.length !== preset.days.length);
  const chip = (on) => `${chipClass}${on ? ` ${activeClass}` : ''}`;

  const toggleDay = (day) =>
    onChange(WEEKDAYS.filter(d => (d === day ? !value.includes(d) : value.includes(d))));

  return (
    <div className="workdays">
      <div className="workdays__chips">
        {WORKDAY_PRESETS.map(p => (
          <button
            key={p.key}
            type="button"
            className={chip(p === preset)}
            aria-pressed={p === preset}
            onClick={() => onChange(p.days)}
          >
            {p.label}
          </button>
        ))}
      </div>

      <button
        type="button"
        className="workdays__toggle"
        aria-expanded={open}
        onClick={() => setOpen(o => !o)}
      >
        Einzelne Tage anpassen (optional) <ChevronDown size={14} />
      </button>

      {open && (
        <div className="workdays__chips">
          {WEEKDAYS.map(day => (
            <button
              key={day}
              type="button"
              className={chip(value.includes(day))}
              aria-pressed={value.includes(day)}
              onClick={() => toggleDay(day)}
            >
              {WEEKDAY_LABELS[day]}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
